import React, { useEffect, useState } from 'react';
import { supabase } from '../supabase';
import '../styles/TopPlayersPanel.css';
import AppIcon from './icons/AppIcon';

export default function TopPlayersPanel({ sport }) {
  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState([]);

  useEffect(() => {
    let mounted = true;
    (async () => {
      setLoading(true);
      try {
        const { data, error } = await supabase.from('profiles').select('display_name, total_xp, photo_url').order('total_xp', { ascending: false }).limit(5);
        if (error) throw error;
        if (mounted) setPlayers((data || []).map(player => ({ displayName: player.display_name, xpEarned: player.total_xp, avatar: player.photo_url })));
      } catch (e) {
        setPlayers([]);
      } finally {
        setLoading(false);
      }
    })();
    return () => { mounted = false; };
  }, [sport]);

  if (loading) return <div className="tp-panel">Chargement...</div>;
  if (!players || players.length === 0) return <div className="tp-panel">Pas encore de classement</div>;

  return (
    <div className="tp-panel">
      <h4><AppIcon name="trophy" size={18} /> Top joueurs — {sport}</h4>
      <div className="tp-list">
        {players.map((p, idx) => (
          <div className="tp-item" key={idx}>
            <div className={`tp-rank ${idx<3? 'medal':''}`}>{idx < 3 ? <AppIcon name="medal" size={17} /> : `#${idx+1}`}</div>
            <div className="tp-avatar">{p.avatar ? <img src={p.avatar} alt="avatar"/> : <div className="tp-initial">{(p.displayName||p.name||'Joueur').charAt(0)}</div>}</div>
            <div className="tp-info">
              <div className="tp-name">{p.displayName || p.name || 'Joueur inconnu'}</div>
              <div className="tp-xp">+{p.xpEarned || p.totalXP || 0} XP</div>
              <div className="tp-bar"><div className="tp-bar-fill" style={{width: `${Math.min((p.xpEarned||0)/2500*100,100)}%`}}/></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
